/**
 * @param node {Node}
 * @return {void}
 */
module.exports = function removeElement(node) {
    node.remove();
}